import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { showUpdatePrompt } from './updatePrompt';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Avisar al usuario cuando haya una versión nueva de la app (PWA).
serviceWorkerRegistration.register({ onUpdate: showUpdatePrompt });
reportWebVitals();
